import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Zap, Heart, Shield, Brain, MessageCircle, Sparkles, Check, Gift, ShoppingCart, Clock, Flame } from 'lucide-react';
import { BonusCarousel } from './BonusCarousel';
const bonuses = [{
  number: 1,
  title: 'Diario de Recarga Mental de 5 Minutos',
  subtitle: '5 minutos al día para tu plan de energía',
  description: 'Para esos días en los que la cabeza no se calla.',
  details: ['Micro ejercicios mentales diarios para bajar ruido en 5 minutos', 'Espacios guiados para soltar pensamientos, pendientes y preocupaciones', 'Te ayuda a cerrar el día con más calma y menos sobrecarga mental'],
  icon: Brain,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6xZLciiVgAQTcjYtrGaDCC/b1portada_diario_de_recarga_mental.png'
}, {
  number: 2,
  title: 'Kit de Emergencia Emocional',
  subtitle: 'Respuestas para el caos diario',
  description: 'Para cuando sientes que vas a explotar.',
  details: ['Tarjetas S.O.S. para crisis con niños, discusiones y momentos de desborde', 'Guías rápidas para manejar ansiedad, culpa y enojo en el momento', 'Te dice qué hacer y qué decir cuando no sabes por dónde empezar'],
  icon: Heart,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3G7SzG2ahym4Aez18FTYxn/b2_portada_kit_emocional.png'
}, {
  number: 3,
  title: 'El Poder del No',
  subtitle: 'Cómo poner límites en familia y trabajo',
  description: 'Decir "no" sin sentirte mala mamá, mala hija o mala empleada.',
  details: ['Guiones de límites claros y respetuosos', 'Frases listas para usar con pareja, familia política, jefes y clientes', 'Te ayuda a dejar de decir que sí a todo y empezar a cuidarte sin culpa'],
  icon: Shield,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wVfRFii2mWtAghxpV7JNMh/b3portada_el_poder_del_no.png'
}, {
  number: 4,
  title: 'Adiós Carga Mental',
  subtitle: 'El plan simple para reducir tu estrés mental',
  description: 'Para dejar de tener todo en la cabeza todo el tiempo.',
  details: ['Método Descargar – Decidir – Delegar explicado paso a paso', 'Listas que de verdad ayudan (no te agregan más trabajo)', 'Mini plan de 21 días para soltar la "carga invisible" que nadie ve, pero tú sí sientes'],
  icon: Zap,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/db4LrxyxxvLdrsasbi9Sfj/b4_portada_adios_carga_mental.png'
}, {
  number: 5,
  title: 'Diálogo Interno',
  subtitle: 'Reprograma tu voz interna',
  description: 'Para dejar de atacarte por dentro cada vez que algo sale mal.',
  details: ['Ejercicios para transformar la voz crítica en una voz aliada', 'Guiones para momentos de culpa, error, comparación con otras mamás', 'Te enseña a hablarte como le hablarías a alguien que quieres'],
  icon: MessageCircle,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3eyJEogzStRr6ptQJhP6YB/b5_portada_dialogo_interno.png'
}, {
  number: 6,
  title: 'Rutinas Exprés para Mamás',
  subtitle: 'Rutinas para recargar energía',
  description: 'Autocuidado realista para días llenos y caóticos.',
  details: ['Rutinas simples de mañana, reset de mediodía y noche', 'Versión "modo mínimo" para esos días donde no puedes más', 'Plan de 21 días para crear 2–3 hábitos que sí puedes sostener'],
  icon: Sparkles,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xbkXSF2EBnEPMJSwpWdTYm/b6_portada_rutinas_expres.png'
}];
export function EbookPromotion() {
  return <div className="relative" data-id="element-43">
      {/* Animated Header with Bold Colors */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      type: 'spring'
    }} className="text-center mb-16 relative" data-id="element-44">
        {/* Animated Background Glow */}
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.3, 0.6, 0.3]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute inset-0 bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-blue-500/20 blur-3xl -z-10" data-id="element-45" />

        {/* Pulsing Badge */}
        <motion.div animate={{
        scale: [1, 1.05, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="inline-flex items-center gap-3 mb-6 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 px-8 py-4 rounded-full shadow-2xl" data-id="element-46">
          <motion.div animate={{
          rotate: [0, 360]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-47">
            <Flame className="w-8 h-8 text-white" data-id="element-48" />
          </motion.div>
          <span className="text-xl font-black text-white uppercase tracking-wider" data-id="element-49">
            OFERTA ESPECIAL POR TIEMPO LIMITADO
          </span>
          <motion.div animate={{
          scale: [1, 1.2, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} data-id="element-50">
            <Clock className="w-8 h-8 text-white" data-id="element-51" />
          </motion.div>
        </motion.div>

        {/* Main Headline - Animated */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-5xl md:text-6xl lg:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-600 via-purple-600 to-blue-600 mb-6 leading-tight" data-id="element-52">
          No es solo un ebook.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-3xl md:text-4xl font-bold text-text-main mb-8 leading-relaxed" data-id="element-53">
          Es un kit completo para bajar culpa, caos y cansancio en tu día a día.
        </motion.p>

        {/* Key Offer Point */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        type: 'spring'
      }} className="bg-gradient-to-r from-pink-50 via-purple-50 to-blue-50 rounded-3xl p-8 max-w-4xl mx-auto border-4 border-transparent bg-clip-padding" style={{
        backgroundImage: 'linear-gradient(white, white), linear-gradient(to right, #ec4899, #8b5cf6, #3b82f6)',
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box'
      }} data-id="element-54">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-55">
            <Gift className="w-10 h-10 text-pink-500" data-id="element-56" />
            <p className="text-2xl md:text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-blue-600" data-id="element-57">
              Hoy recibes:
            </p>
          </div>
          <p className="text-xl md:text-2xl font-bold text-text-main mb-4" data-id="element-58">
            El ebook principal +{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600" data-id="element-59">
              6 bonos 100% gratis
            </span>
          </p>
          <p className="text-lg text-text-muted font-medium" data-id="element-60">
            Solo mientras esta oferta esté activa.
          </p>
        </motion.div>

        {/* Urgency Message */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="text-xl md:text-2xl text-text-main font-semibold mt-8 max-w-3xl mx-auto" data-id="element-61">
          Empieza hoy a recuperar tu energía con un plan simple, paso a paso.
        </motion.p>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="text-lg md:text-xl text-pink-600 font-bold mt-4" data-id="element-62">
          👇 Haz clic y consigue ahora tu kit completo antes de que se cierre
          esta oferta.
        </motion.p>
      </motion.div>

      {/* Main Ebook Card */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="bg-gradient-to-br from-primary to-primary-dark text-white rounded-3xl p-8 md:p-12 mb-16 shadow-2xl" data-id="element-63">
        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-64">
          {/* Left: Content */}
          <div data-id="element-65">
            <div className="flex items-center gap-4 mb-6" data-id="element-66">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center" data-id="element-67">
                <BookOpen className="w-8 h-8" data-id="element-68" />
              </div>
              <div data-id="element-69">
                <p className="text-sm font-semibold text-white/80 uppercase tracking-wide" data-id="element-70">
                  Ebook Principal
                </p>
                <h3 className="text-3xl md:text-4xl font-serif" data-id="element-71">
                  Autocuidado de 5 Minutos
                </h3>
              </div>
            </div>

            <p className="text-xl text-white/90 mb-6" data-id="element-72">
              Plan para recuperar tu energía sin culpa, sin perfeccionismo, sin
              necesitar horas que no tienes.
            </p>

            <div className="space-y-3" data-id="element-73">
              <div className="flex items-start gap-3" data-id="element-74">
                <Check className="w-5 h-5 mt-1 flex-shrink-0" data-id="element-75" />
                <p className="text-white/90" data-id="element-76">Plan de 30 días paso a paso</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-77">
                <Check className="w-5 h-5 mt-1 flex-shrink-0" data-id="element-78" />
                <p className="text-white/90" data-id="element-79">Solo 5 minutos al día</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-80">
                <Check className="w-5 h-5 mt-1 flex-shrink-0" data-id="element-81" />
                <p className="text-white/90" data-id="element-82">Sin teoría, solo acción</p>
              </div>
            </div>
          </div>

          {/* Right: Book Cover Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="relative" data-id="element-83">
            <div className="bg-white/10 rounded-2xl p-6 backdrop-blur-sm" data-id="element-84">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/knWff1sx5QNp2HtdAdquU7/cover_autocuidado.png" alt="Autocuidado de 5 Minutos para Mamás Agotadas" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-85" />
            </div>
          </motion.div>
        </div>
      </motion.div>

      {/* Bonuses Section */}
      <div className="mb-12" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mb-12" data-id="element-87">
          <h3 className="text-3xl md:text-4xl font-serif text-text-main mb-4" data-id="element-88">
            🎁 Hoy Incluye 6 Bonos 100% Gratis
          </h3>
          <p className="text-xl text-text-muted" data-id="element-89">
            Herramientas prácticas para cada situación que enfrentas
          </p>
        </motion.div>

        {/* Mobile: Carousel */}
        <BonusCarousel data-id="element-90" />

        {/* Desktop: Detailed Cards */}
        <div className="hidden md:grid md:grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-91">
          {bonuses.map((bonus, index) => <motion.div key={bonus.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.5 + index * 0.1
        }} className="bg-white rounded-3xl overflow-hidden shadow-xl relative" data-id="element-92">
              {/* Bonus Number Badge */}
              <div className="absolute top-6 right-6 z-10" data-id="element-93">
                <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center font-bold shadow-lg" data-id="element-94">
                  #{bonus.number}
                </div>
              </div>

              {/* Book Cover Image */}
              <div className="relative h-80 bg-gradient-to-br from-amber-50 to-stone-100 overflow-hidden" data-id="element-95">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain p-8" data-id="element-96" />
              </div>

              {/* Content */}
              <div className="p-8" data-id="element-97">
                <div className="flex items-start gap-3 mb-4" data-id="element-98">
                  <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-99">
                    <bonus.icon className="w-5 h-5 text-primary" data-id="element-100" />
                  </div>
                  <div data-id="element-101">
                    <h4 className="text-2xl font-serif text-text-main mb-2" data-id="element-102">
                      {bonus.title}
                    </h4>
                    <p className="text-sm font-semibold text-primary mb-3" data-id="element-103">
                      {bonus.subtitle}
                    </p>
                  </div>
                </div>

                <p className="text-base text-text-main font-medium mb-4 italic" data-id="element-104">
                  {bonus.description}
                </p>

                <ul className="space-y-3" data-id="element-105">
                  {bonus.details.map((detail, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-106">
                      <Check className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-107" />
                      <span className="text-sm text-text-muted leading-relaxed" data-id="element-108">
                        {detail}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Value Proposition */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 1.1
    }} className="bg-gradient-to-br from-amber-50 to-stone-50 rounded-3xl p-8 md:p-12 text-center shadow-xl" data-id="element-109">
        <div className="mb-8" data-id="element-110">
          <p className="text-text-muted mb-2 text-lg" data-id="element-111">
            Valor Total del Paquete Completo
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-112">
            <span className="text-4xl text-text-muted line-through" data-id="element-113">
              $250.00 USD
            </span>
            <span className="text-6xl md:text-7xl font-bold text-primary" data-id="element-114">
              $9.95
            </span>
          </div>
          <p className="text-xl text-text-main font-semibold mb-2" data-id="element-115">
            1 Ebook Principal + 6 Bonos Completos
          </p>
          <p className="text-lg text-text-muted" data-id="element-116">
            Acceso Inmediato • Garantía de 30 Días
          </p>
        </div>

        <motion.a href="https://mikioscodigital.com/cart/51727945761049:1" target="_blank" rel="noopener" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="bg-gradient-to-r from-pink-500 to-blue-500 hover:from-pink-600 hover:to-blue-600 text-white px-12 py-6 rounded-full text-xl font-bold shadow-xl transition-all mb-6 flex items-center justify-center gap-3 mx-auto cursor-pointer" data-id="element-117">
          <ShoppingCart className="w-6 h-6" data-id="element-118" />
          QUIERO MI PLAN DE AUTOCUIDADO HOY
        </motion.a>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-text-muted" data-id="element-119">
          <div className="flex items-center gap-2" data-id="element-120">
            <Check className="w-4 h-4 text-primary" data-id="element-121" />
            <span data-id="element-122">Descarga instantánea</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-123">
            <Check className="w-4 h-4 text-primary" data-id="element-124" />
            <span data-id="element-125">Formato PDF</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-126">
            <Check className="w-4 h-4 text-primary" data-id="element-127" />
            <span data-id="element-128">Compatible con todos los dispositivos</span>
          </div>
        </div>
      </motion.div>
    </div>;
}